export default __webpack_public_path__ + "static/media/snap.7ec10db6.jpg";